import MicroModal from 'micromodal';
import { defaultSettings } from './settings';

export const closeModal = () => {
    const modalOpen = document.querySelector('.modal.is-open');
    if (modalOpen !== null) {
        const modalOpenId = modalOpen.getAttribute('id');
        if (modalOpenId !== null) {
            MicroModal.close(modalOpenId);
        }
    }
};

export const openNextModal = (nextModalId?: string) => {
    const modalOpen = document.querySelector('.modal.is-open');
    if (modalOpen !== null) {
        const modalOpenId = modalOpen.getAttribute('id');
        if (modalOpenId !== null) {
            MicroModal.close(modalOpenId);
        }
    }
    if (nextModalId === undefined) {
        return;
    }
    MicroModal.show(nextModalId, defaultSettings);
};
